import it from '../translations/it.source.json'

export default { ...it }
